export default class AppVersion {
  constructor (data) {
    this.file = data.file;
    this.version = data.version;
    this.noteNew = data.noteNew;
    this.thumbnail = data.thumbnail;
    this.compatibility = data.compatibility;
    this.category = data.category;
    this.screenshots = data.screenshots;
    this.isCurrent = data.isCurrent;
  }
}
